/* eslint-disable @typescript-eslint/no-explicit-any */
import { ChangeDetectorRef, Component, NgZone } from '@angular/core';
import { EventsRegistrationsAdminResponse } from '../../../models/events/eventRegistrationGridResponse';
import { AuthService } from 'projects/app-core/src/auth/auth.service';
import { EventsService } from '../../../services/events.service';
import {
  EventRegistrationFilter,
  EventRegistrationGridRequest,
  EventRegistrationSearch,
} from '../../../models/events/eventRegistrationGridRequest';
import { ToastService } from 'projects/app-core/src/app/services/toastr.service';
import * as moment from 'moment';
import { UtilsService } from 'projects/app-core/src/service/utils.service';
import { lastValueFrom } from 'rxjs';
import { AnyoSortDirection } from 'projects/app-core/src/models/gridRequest';
import { download, generateCsv, mkConfig } from 'export-to-csv';
import { IAnyoError } from 'projects/app-core/src/models/errorModal';
import { ActivatedRoute } from '@angular/router';
import {
  AddEventRegistrationCSVRequest,
  AdminEventRegistrationRequestCSVData,
  AdminEventRegistrationResponse,
  EventRegistrationErrorRow,
  EventRegistrationErrorRowValidation,
} from '../../../models/events/AddEventRegistrationRequest';
import { AnyoEvents } from '../../../models/events/AnyoEvents';
import { AnyoComponent } from 'projects/app-core/src/app/models/AnyoComponent';

interface CheckBoxOptions {
  label: string;
  value: string;
  checked: boolean;
}
@Component({
  selector: 'app-manage-registrations',
  templateUrl: './manage-registrations.component.html',
  styleUrl: './manage-registrations.component.scss',
})
export class ManageRegistrationsComponent extends AnyoComponent {
  eventId = '';
  totalCount: number = 0;
  tableGridQuery: EventRegistrationGridRequest | undefined;
  eventsLoading!: boolean;
  pageSize: number = 10;
  pageSizeOptions = [10, 20, 50, 100];
  eventRegistrationTableCurrentPageNo = 1;
  eventRegistrationTableTotalCount = 0;
  globalSearchInput = '';
  eventRegistrationData!: EventsRegistrationsAdminResponse[];
  emailColumnSearch = '';
  isEventsMenu: boolean = false;
  ispaymentTypeMenu: boolean = false;
  paymentTypeCheckBoxOptions: CheckBoxOptions[] = [];
  dateFormat = 'dd/MM/yyyy';
  eventsRegistrationColumnFilterDate: Date[] | undefined;
  eventNameFilterCheckBoxOptions: CheckBoxOptions[] = [];
  showTestEvents = false;
  selectedRegistrationMode: string | null = null;
  isRegistrationModeMenu = false;
  event: AnyoEvents | undefined = undefined;
  isCsvModalVisible = false;
  csvHeaders: string[] = [];
  isRegistrationResultModalVisible = false;
  registrationResult: AdminEventRegistrationResponse | undefined;
  isCsvValidationModalVisible = false;
  invalidCsvRows: EventRegistrationErrorRowValidation[] = [];

  constructor(
    auth: AuthService,
    private events: EventsService,
    private toastService: ToastService,
    public utils: UtilsService,
    private activatedRoute: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
  ) {
    super(auth);
  }

  onInputChange() {}

  async testEventChangeFn(flag: boolean) {
    if (flag) {
      this.tableGridQuery!.filters!.HIDE_TEST_REGISTRATION = ['true'];
    } else {
      this.tableGridQuery!.filters!.HIDE_TEST_REGISTRATION = ['false'];
    }
    await this.listEventRegistration();
  }

  getRegistrationModeFilter() {
    return this.selectedRegistrationMode ? [this.selectedRegistrationMode] : [];
  }

  getUserEmailFilter() {
    return this.emailColumnSearch ? this.emailColumnSearch : '';
  }

  async userEmailSearchFn() {
    this.emailColumnSearch = this.emailColumnSearch.trim();
    if (this.emailColumnSearch.length) {
      if (!this.tableGridQuery!.searchQuery) {
        this.tableGridQuery!.searchQuery = {
          [EventRegistrationSearch.USER_EMAIL]: '',
        };
      }
      this.tableGridQuery!.searchQuery!.USER_EMAIL = this.getUserEmailFilter();
      await this.listEventRegistration();
    }
  }

  async resetUserEmailSearch() {
    this.emailColumnSearch = '';
    if (this.tableGridQuery?.searchQuery) {
      delete this.tableGridQuery.searchQuery[
        EventRegistrationSearch.USER_EMAIL
      ];
    }
    await this.listEventRegistration();
  }

  async applyRegistrationModeFilter() {
    this.isRegistrationModeMenu = false;
    this.tableGridQuery!.filters!.OUTSIDE_REGISTRATION =
      this.getRegistrationModeFilter();
    this.tableGridQuery!.page = 1;
    await this.listEventRegistration();
  }

  async resetRegistrationModeFilter() {
    if (this.tableGridQuery?.filters) {
      this.tableGridQuery.filters[
        EventRegistrationFilter.OUTSIDE_REGISTRATION
      ] = [];
    }

    this.selectedRegistrationMode = null;
    this.isRegistrationModeMenu = false;
    this.tableGridQuery!.page = 1;
    await this.listEventRegistration();
  }

  async resetUserEmailFilter() {
    this.emailColumnSearch = '';
    if (this.tableGridQuery?.searchQuery) {
      delete this.tableGridQuery.searchQuery[
        EventRegistrationSearch.USER_EMAIL
      ];
    }
    this.tableGridQuery!.globalSearch = [];
    await this.listEventRegistration();
  }
  async dateFilterFn() {
    if (
      this.eventsRegistrationColumnFilterDate &&
      this.eventsRegistrationColumnFilterDate.length
    ) {
      const startDate = moment(this.eventsRegistrationColumnFilterDate[0])
        .startOf('day')
        .toDate();
      const endDate = moment(this.eventsRegistrationColumnFilterDate[1])
        .endOf('day')
        .toDate();
      const isToday = moment(startDate).isSame(endDate, 'day');
      this.tableGridQuery = {
        export: false,
        sort: undefined,
        globalSearch: [],
        page: 1,
        pageSize: this.pageSize,
        dateFilters: {
          REGISTRATION_DATE: {
            from: isToday ? moment().startOf('day').toDate() : startDate,
            to: isToday ? moment().endOf('day').toDate() : endDate,
          },
        },
      };

      await this.listEventRegistration();
    }
  }

  async listEventRegistration() {
    try {
      this.eventsLoading = true;
      const tableData = await lastValueFrom(
        this.events.listEventRegistration(this.tableGridQuery!),
      );
      tableData.data.forEach((data) => {
        data.paymentTypeColor = this.utils.getRandomColor();
      });
      this.eventRegistrationData = tableData.data;
      this.cd.detectChanges();
      this.totalCount = tableData.totalRecords;
      this.eventRegistrationTableTotalCount = tableData.totalRecords;
      this.paymentTypeCheckBoxOptions = [];
      tableData.filterOptions!.eventPaymentTypes.map((data) => {
        this.paymentTypeCheckBoxOptions.push({
          checked: false,
          label: this.utils.convertToTitleCase(data),
          value: data,
        });
      });
      // this.eventNameFilterCheckBoxOptions = [];
      // tableData.filterOptions!.eventNames.map((data) => {
      //   this.eventNameFilterCheckBoxOptions.push({
      //     checked: false,
      //     label: data,
      //     value: data,
      //   });
      // });
      this.eventsLoading = false;
    } catch (e) {
      this.eventsLoading = false;
      this.toastService.showError('Something went wrong');
    }
  }

  // eventNameFilter(eventName: string[]) {
  //   if (eventName && eventName.length) {
  //     if (!this.tableGridQuery!.filters) {
  //       this.tableGridQuery!.filters = {
  //         [EventRegistrationFilter.HIDE_TEST_REGISTRATION]: [],
  //         [EventRegistrationFilter.PAYMENT_TYPE]: [],
  //         [EventRegistrationFilter.EVENT_NAME]: [],
  //       };
  //     }
  //     this.tableGridQuery!.filters!.EVENT_NAME = eventName;
  //   }
  // }

  paymentTypeFilter(paymentType: any[]) {
    if (paymentType && paymentType?.length) {
      if (!this.tableGridQuery!.filters) {
        this.tableGridQuery!.filters = {
          [EventRegistrationFilter.HIDE_TEST_REGISTRATION]: [],
          [EventRegistrationFilter.OUTSIDE_REGISTRATION]:
            this.getRegistrationModeFilter(),
          [EventRegistrationFilter.PAYMENT_TYPE]: [],
          [EventRegistrationFilter.EVENT_NAME]: [],
        };
      }
      this.tableGridQuery!.filters!.PAYMENT_TYPE = paymentType;
    }
  }

  async resetFilter() {
    this.tableGridQuery = {
      dateFilters: undefined,
      export: false,
      filters: {
        [EventRegistrationFilter.HIDE_TEST_REGISTRATION]: [
          this.showTestEvents ? 'true' : 'false',
        ],
        [EventRegistrationFilter.OUTSIDE_REGISTRATION]:
          this.getRegistrationModeFilter(),
        [EventRegistrationFilter.PAYMENT_TYPE]: [],
        [EventRegistrationFilter.EVENT_NAME]: [this.eventId],
      },
      from: undefined,
      globalSearch: [],
      searchQuery: undefined,
      sort: undefined,
      to: undefined,
      page: this.eventRegistrationTableCurrentPageNo,
      pageSize: this.pageSize,
    };
    this.globalSearchInput = '';
    this.emailColumnSearch = '';
    await this.listEventRegistration();
  }

  async resetDateFilter() {
    this.eventsRegistrationColumnFilterDate = undefined;

    if (this.tableGridQuery) {
      this.tableGridQuery.dateFilters = undefined;
      this.tableGridQuery.page = 1;
    }

    await this.listEventRegistration();
  }

  async searchGlobal() {
    if (this.globalSearchInput.length) {
      this.tableGridQuery?.globalSearch?.push(this.globalSearchInput.trim());
      await this.listEventRegistration();
    }
  }

  async nzPageIndexChange(page: number) {
    if (this.tableGridQuery) {
      this.tableGridQuery!.page = page;
      await this.listEventRegistration();
    }
  }

  async nzPageSizeChange(pageSize: number) {
    this.tableGridQuery!.pageSize = pageSize;
    await this.listEventRegistration();
  }

  async sortRegisteredDates($event: string | null) {
    if ($event) {
      this.tableGridQuery = {
        dateFilters: undefined,
        export: false,
        filters: {
          [EventRegistrationFilter.HIDE_TEST_REGISTRATION]: [
            this.showTestEvents ? 'true' : 'false',
          ],
          [EventRegistrationFilter.OUTSIDE_REGISTRATION]:
            this.getRegistrationModeFilter(),
          [EventRegistrationFilter.PAYMENT_TYPE]: [],
          [EventRegistrationFilter.EVENT_NAME]: [],
        },
        from: undefined,
        globalSearch: [],
        page: this.eventRegistrationTableCurrentPageNo,
        pageSize: this.pageSize,
        searchQuery: undefined,
        sort: {
          REGISTRATION_DATE:
            $event === 'ascend'
              ? AnyoSortDirection.ASC
              : AnyoSortDirection.DESC,
        },
        to: undefined,
      };
    }
    await this.listEventRegistration();
  }

  async getEvents(eventId: string) {
    this.events.getEvents(eventId).subscribe({
      next: (response) => {
        this.event = response;
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }
  async ready(): Promise<void> {
    this.eventsLoading = true;
    if (this.user) {
      this.activatedRoute.queryParamMap.subscribe((params) => {
        this.eventId = params.get('eventId') || '';
      });
      this.tableGridQuery = {
        dateFilters: undefined,
        export: false,
        filters: {
          [EventRegistrationFilter.HIDE_TEST_REGISTRATION]: ['false'],
          [EventRegistrationFilter.OUTSIDE_REGISTRATION]: [],
          [EventRegistrationFilter.PAYMENT_TYPE]: [],
          [EventRegistrationFilter.EVENT_NAME]: [this.eventId],
        },
        from: undefined,
        globalSearch: [],
        page: 1,
        pageSize: this.pageSize,
        searchQuery: undefined,
        sort: undefined,
        to: undefined,
      };
      await this.getEvents(this.eventId);
      await this.listEventRegistration();
    }
  }

  exportRegistrationTable() {
    this.eventsLoading = true;
    this.tableGridQuery!.export = true;
    this.events.listEventRegistration(this.tableGridQuery!).subscribe({
      next: (response) => {
        try {
          const tableData = response.data.map((data) => {
            return {
              id: data.id,
              registerOn: this.utils.convertEpochToFormattedDate(
                data.registerOn,
              ),
              eventId: data.eventId,
              eventName: data.eventName,
              eventCategory: data.eventCategory,
              userId: data.userId,
              userName: data.userName,
              userEmail: data.userEmail,
              amount: data.amount,
              paymentType: data.paymentType,
            };
          });
          const csvData = tableData as unknown as Record<
            string,
            string | null | undefined
          >[];
          const csvConfig = mkConfig({ useKeysAsHeaders: true });
          const csv = generateCsv(csvConfig)(csvData);
          download(csvConfig)(csv);
          this.eventsLoading = false;
        } catch (e) {
          this.toastService.showError('Export Error');
          this.eventsLoading = false;
        }
      },
      error: (error) => {
        this.eventsLoading = false;
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
    });
  }

  selectedCsvFile: File | null = null;
  selectedCsvData: AdminEventRegistrationRequestCSVData[] = [];
  csvLoading: boolean = false;

  downloadSampleTemplate(): void {
    const sampleData: Record<string, string>[] = [
      {
        'Email (Required)': 'jane.doe@example.com',
        'First Name (Optional)': 'Jane',
        'Last Name (Optional)': 'Doe',
        'Registered From (Optional)': 'Admin',
        'Registered Time (Optional)': moment().format('DD-MM-YYYY HH:mm:ss'),
        'Registration Approval Status (Optional)': 'Approved',
      },
    ];
    const csvConfig = mkConfig({
      useKeysAsHeaders: true,
      filename: `event_registration_sample_template_${moment().format('DD-MM-yyyy_HH-mm-ss')}`,
    });
    const csv = generateCsv(csvConfig)(sampleData);
    download(csvConfig)(csv);
  }

  onCsvFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      if (file.type === 'text/csv' || file.name.endsWith('.csv')) {
        this.selectedCsvFile = file;
        const reader = new FileReader();

        reader.onload = () => {
          const text = reader.result as string;
          this.ngZone.run(() => {
            this.selectedCsvData = this.parseCsvToJson(text);
            this.csvHeaders = Object.keys(this.selectedCsvData[0] || {});
          });
        };

        reader.readAsText(file);
      } else {
        input.value = '';
        this.selectedCsvFile = null;
        this.selectedCsvData = [];
      }
    }
  }

  uploadCsv(): void {
    if (!this.selectedCsvData.length) return;
    const { validRows, invalidRows } = this.validateCsvData(
      this.selectedCsvData,
    );

    if (invalidRows.length) {
      this.invalidCsvRows = invalidRows;
      this.isCsvValidationModalVisible = true;
      return;
    }

    const req: AddEventRegistrationCSVRequest = {
      eventId: this.eventId,
      csvData: validRows,
    };
    this.csvLoading = true;
    this.events.addEventRegistration(req).subscribe({
      next: async (response) => {
        this.selectedCsvFile = null;
        this.selectedCsvData = [];
        this.registrationResult = response;
        this.isRegistrationResultModalVisible = true;
        await this.listEventRegistration();
      },
      error: (error) => {
        const errorBody = error.error as IAnyoError;
        this.toastService.showAnyoErrorToast(errorBody.description);
      },
      complete: () => {
        this.csvLoading = false;
      },
    });
  }

  private validateCsvData(data: AdminEventRegistrationRequestCSVData[]): {
    validRows: AdminEventRegistrationRequestCSVData[];
    invalidRows: EventRegistrationErrorRowValidation[];
  } {
    const validRows: AdminEventRegistrationRequestCSVData[] = [];
    const invalidRows: EventRegistrationErrorRowValidation[] = [];

    data.forEach((row, index) => {
      const issues: string[] = [];

      if (!row.email?.trim()) {
        issues.push('Email missing');
      } else if (!this.utils.validateEmail(row.email)) {
        issues.push('Invalid email format');
      }

      if (issues.length) {
        invalidRows.push({
          row: index + 2,
          email: row.email?.trim() || 'N/A',
          reason: issues.join(', '),
        });
        return;
      }

      validRows.push(row);
    });

    return { validRows, invalidRows };
  }

  registrationSuccessCount(): number {
    if (!this.registrationResult) return 0;
    return (
      this.registrationResult.total -
      this.registrationResult.failed.length -
      this.registrationResult.skipped.length
    );
  }

  exportRegistrationRows(
    rows: EventRegistrationErrorRow[],
    label: 'failed' | 'skipped',
  ): void {
    if (!rows?.length) return;
    const csvData = rows as unknown as Record<
      string,
      string | null | undefined
    >[];
    const csvConfig = mkConfig({
      useKeysAsHeaders: true,
      filename: `event_registration_${label}_${moment().format('DD-MM-yyyy_HH-mm-ss')}`,
    });
    const csv = generateCsv(csvConfig)(csvData);
    download(csvConfig)(csv);
  }

  viewCsvData(): void {
    this.csvHeaders = this.selectedCsvData.length
      ? Object.keys(this.selectedCsvData[0])
      : [];
    this.isCsvModalVisible = true; // Always show modal
    this.cd.detectChanges();
    console.log('CSV Data:', this.selectedCsvData, this.csvHeaders);
  }

  parseCsvToJson(csvText: string): AdminEventRegistrationRequestCSVData[] {
    const lines = csvText
      .trim()
      .split('\n')
      .filter((line) => line.trim().length > 0);
    if (lines.length < 2) return [];

    const rawHeaders = this.parseCsvLine(lines[0]);
    this.csvHeaders = rawHeaders; // keep original for modal display

    // Prepare clean keys for object mapping
    const cleanHeaders = rawHeaders.map((h) =>
      h.toLowerCase().replace(/\s+/g, ''),
    );

    return lines
      .slice(1)
      .map((line) => {
        const values = this.parseCsvLine(line);
        const row: Record<string, string> = {};

        cleanHeaders.forEach((key, i) => {
          row[key] = values[i] ?? '';
        });

        return row as AdminEventRegistrationRequestCSVData;
      })
      .filter((row) => !this.isBlankCsvRow(row));
  }

  private isBlankCsvRow(row: Record<string, string>): boolean {
    return Object.values(row).every((value) => !/[a-zA-Z0-9]/.test(value));
  }

  parseCsvLine(line: string): string[] {
    const result: string[] = [];
    let current = '';
    let insideQuotes = false;

    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      const nextChar = line[i + 1];

      if (char === '"' && insideQuotes && nextChar === '"') {
        current += '"'; // Escaped quote
        i++; // skip next quote
      } else if (char === '"') {
        insideQuotes = !insideQuotes;
      } else if (char === ',' && !insideQuotes) {
        result.push(this.stripOuterQuotes(current.trim()));
        current = '';
      } else {
        current += char;
      }
    }

    result.push(this.stripOuterQuotes(current.trim())); // last field
    return result;
  }

  // Strip outer quotes if present
  stripOuterQuotes(str: string): string {
    if (str.startsWith('"') && str.endsWith('"')) {
      return str.slice(1, -1).replace(/""/g, '"');
    }
    return str;
  }
}
